export default __webpack_public_path__ + "static/data-analytics-optimized-99758ffbc8f8759e99cd49c677ad6652.jpg";